import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  margin-bottom: 48px;
  button {
    margin-top: 12px;
  }
`;

interface BeneficiaryLoadErrorProps {
  refetch: () => unknown;
}

const BeneficiaryLoadError: React.FC<BeneficiaryLoadErrorProps> = ({
  refetch
}) => {
  return (
    <StyledDiv>
      <div>Unable to load Beneficiary details at this time.</div>
      <button onClick={refetch}>Click to try again!</button>
    </StyledDiv>
  );
};

export default BeneficiaryLoadError;
